import { render, staticRenderFns } from "./UcCompanyBankAccountCard.yaml?vue&type=template&id=499dafd6&component"
import script from "./UcCompanyBankAccountCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanyBankAccountCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports